// extracted by mini-css-extract-plugin
export default {"code":"Pnr_code__1sdVR"};